module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/community-5a368b69fd945538f692fb29a0149f50.png";